import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { deliveyFeeActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const DeliveryFees = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
  const deliveryFees = useSelector((state) => state.deliveryFees);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "ordertype", headerName: "Order Type", width: 150 },
    { field: "deliverytype", headerName: "Delivery Type", width: 150 },
    { field: "deliverytime", headerName: "Delivery Time", width: 150 },
    {
      field: "extrachargefordelivery",
      headerName: "Extra Charge for Delivery",
      width: 150,
    },
    {
      field: "seconddeliverytime",
      headerName: "Second Delivery Time",
      width: 150,
    },
    {
      field: "surchargesecondoption",
      headerName: "Surcharge Second Option",
      width: 150,
    },
    { field: "thirddeliverytime", headerName: "Third Delivery Time", width: 150 },
    {
      field: "surchargethirdoption",
      headerName: "Surcharge Third Option",
      width: 150,
    },
    { field: "weighttype", headerName: "Weight Type", width: 150 },
    { field: "minitems", headerName: "Min Items", width: 150 },
    { field: "currencytype", headerName: "Currency Type", width: 150 },
    { field: "priceforminitem", headerName: "Price for Min Item", width: 150 },
    { field: "numadditionlitem", headerName: "Num Additionl Item", width: 150 },
    {
      field: "priceadditionalitem",
      headerName: "Price Additional Item",
      width: 150,
    },
    { field: "status", headerName: "Status", width: 150 },
  ];

  const recordIdentifier = "ordertype";

  useEffect(() => {
    dispatch(deliveyFeeActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
      {deliveryFees && (
        <DataTable
          loading={deliveryFees?.loading}
          rows={deliveryFees?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="deliveyFeeActions"
          search ={searchQuery}
        />
      )}
    </Box>
  );
};

export default DeliveryFees;
